<template>
    <div v-show="bannerStore.show()" id="announcement-banner" class="uk-margin-remove uk-alert uk-alert-primary uk-text-center" style="padding-top: 8px !important; padding-bottom: 8px !important;" uk-alert>
        <span class="uk-alert-close" style="top: 5px; cursor: pointer;" @click="hide">
            <svg fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" viewBox="0 0 24 24" width="24">
                <path d="M0 0h24v24H0z" fill="none" stroke="none" />
                <path d="M18 6l-12 12" />
                <path d="M6 6l12 12" />
            </svg>
        </span>
        <div v-if="announcement.link">
            <a :class="announcement.linkclass" :href="announcement.link" class="uk-flex uk-flex-middle uk-flex-center uk-text-bold">
                {{ announcement.content }}
                <svg fill="none" height="22" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" stroke="none"></path>
                    <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
            </a>
        </div>
        <div v-else class="uk-text-uppercase">
            {{ announcement.content }}
        </div>
    </div>
</template>

<script setup>
import {useBannerStore} from "../../stores/BannerStore";

const props = defineProps({
    announcement: Object
})

const bannerStore = useBannerStore()

function hide() {
    bannerStore.hide()
}
</script>

<style scoped>
#announcement-banner {
    font-size: 19px;
}

#announcement-banner a {
    text-decoration: none !important;
    color: #fff;
    text-transform: uppercase;
}
</style>
